import { getFormValues } from 'redux-form';
import { FORM_LOGIN_NAME } from '../../../authentication/consts';

export const mapState = (state) => ({
	formValues: getFormValues(FORM_LOGIN_NAME)(state),
});
